<template>
    <div></div>
</template>

<script>
export default {
  name: 'Logout',
  created: function () {
    localStorage.clear()
    this.$router.push('/login')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue